import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import NavigationHeader from './components/common/NavigationHeader';
import LoaderAnimation from './components/common/LoaderAnimation';
import HeroSlider from './components/sections/HeroSlider';
import AboutSection from './components/sections/AboutSection';
import ProjectTypesSection from './components/sections/ProjectTypesSection';
import TeamSection from './components/sections/TeamSection';
// Preserved for future: import PortfolioSection from './components/preserved/PortfolioSection';
// Preserved for future: import PricingSection from './components/preserved/PricingSection';
// Preserved for future: import ContentSection from './components/preserved/ContentSection';
// Preserved for future: import TestimonialSection from './components/preserved/TestimonialSection';
import AppSection from './components/sections/AppSection';
import BlogSection from './components/sections/BlogSection';
import AddressSection from './components/sections/AddressSection';
import FooterSection from './components/common/FooterSection';
import ScrollTop from './components/common/ScrollTop';
import EnergyCalculator from './components/tools/EnergyCalculator/EnergyCalculator';

// HomePage component - the main landing page
function HomePage() {
  useEffect(() => {
    // Initialize theme JavaScript after component mount
    const initializeTheme = () => {
      // Initialize WOW animations if available
      if (window.WOW) {
        new window.WOW().init();
      }

      // Smooth scroll initialization
      if (window.$ && window.$.fn.scrollTo) {
        window.$('.scroll').on('click', function(e) {
          e.preventDefault();
          const target = window.$(this).attr('href');
          if (target && window.$(target).length) {
            window.$('html, body').animate({
              scrollTop: window.$(target).offset().top - 90
            }, 1000);
          }
        });
      }

      // Initialize parallax if available
      if (window.$ && window.$.fn.parallaxie) {
        window.$('.parallaxie').parallaxie();
      }
    };

    // Delay initialization to ensure jQuery is loaded
    setTimeout(initializeTheme, 100);
  }, []);

  return (
    <>
      {/* Navigation */}
      <NavigationHeader />

      {/* Main Content - EXACT SECTIONS AS ORIGINAL */}

      {/* Slider Section */}
      <HeroSlider />

      {/* About Section */}
      <AboutSection />

      {/* Project Types Section - "Project Types We Pursue" */}
      <ProjectTypesSection />

      {/* Team Section - "Utility Benefits" */}
      <TeamSection />

      {/* PRESERVED COMMENTED SECTIONS */}
      {/* Portfolio Section - Commented in original */}
      {/* <PortfolioSection /> */}

      {/* Pricing Section - Commented in original */}
      {/* <PricingSection /> */}

      {/* Content Section - Commented in original */}
      {/* <ContentSection /> */}

      {/* Testimonial Section - Commented in original */}
      {/* <TestimonialSection /> */}

      {/* App Section - "The Public Benefits" */}
      <AppSection />

      {/* Blog Section - "Publicly Owned Power" & "Large Load Data" */}
      <BlogSection />

      {/* Address/Contact Section */}
      <AddressSection />

      {/* Footer */}
      <FooterSection />

      {/* Scroll to Top */}
      <ScrollTop />
    </>
  );
}

// Main App with routing
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/cooperative_pilot_energy_rate_eval_tool" element={<EnergyCalculator />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;